import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ForgotPasswordPageContainerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "ForgotPasswordPageContainer" */
      './ForgotPasswordPageContainer.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
